/* sinefiltr. — theme script */
(() => {
  'use strict';

  const SF = window.SF || {};
  SF.routes = SF.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const icon = (name) => {
    const paths = {
      plus: '<path d="M12 5v14M5 12h14"/>',
      minus: '<path d="M5 12h14"/>',
      trash: '<path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/>',
      bag: '<path d="M5 8h14l-1 13H6z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/>'
    };
    return `<svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paths[name] || ''}</svg>`;
  };

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = parseInt(cents.replace(/[^\d-]/g, ''), 10);
    const fmt = format || SF.moneyFormat || '{{amount}} TL';
    const re = /\{\{\s*(\w+)\s*\}\}/;
    const delim = (n, p, t = ',', d = '.') => {
      if (isNaN(n) || n == null) return '0';
      const parts = (n / 100).toFixed(p).split('.');
      return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + t) + (parts[1] ? d + parts[1] : '');
    };
    const m = fmt.match(re);
    if (!m) return fmt;
    const map = {
      amount: () => delim(cents, 2),
      amount_no_decimals: () => delim(cents, 0),
      amount_with_comma_separator: () => delim(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: () => delim(cents, 0, '.', ','),
      amount_with_apostrophe_separator: () => delim(cents, 2, "'", '.'),
      amount_with_space_separator: () => delim(cents, 2, ' ', ','),
      amount_no_decimals_with_space_separator: () => delim(cents, 0, ' ', ',')
    };
    return fmt.replace(re, (map[m[1]] || map.amount)());
  }
  SF.formatMoney = formatMoney;

  /* ---------- countdown (Türkiye, UTC+3) ---------- */
  function initCountdown(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    const OFFSET = 3 * 3600e3;
    const cutoff = parseInt(el.dataset.cutoff || '16', 10);
    const end = (el.dataset.end || '').trim();
    const lbl = $('[data-cd-label]', el);
    const H = $('[data-cd-h]', el), M = $('[data-cd-m]', el), S = $('[data-cd-s]', el);
    const pad = (n) => String(n).padStart(2, '0');

    function target(now) {
      if (end) {
        const t = Date.parse(end.replace(' ', 'T') + (/[zZ]|[+-]\d\d:?\d\d$/.test(end) ? '' : ':00+03:00'));
        if (!isNaN(t)) return { t, text: el.dataset.campaign, campaign: true };
      }
      const tr = new Date(now + OFFSET);
      let base = Date.UTC(tr.getUTCFullYear(), tr.getUTCMonth(), tr.getUTCDate(), cutoff, 0, 0) - OFFSET;
      let sameDay = true;
      const isSunday = (ts) => new Date(ts + OFFSET).getUTCDay() === 0;
      if (base <= now || isSunday(base)) { base += 864e5; sameDay = false; }
      while (isSunday(base)) { base += 864e5; sameDay = false; }
      return { t: base, text: sameDay ? el.dataset.today : el.dataset.next };
    }

    function tick() {
      const now = Date.now();
      const tg = target(now);
      let diff = Math.max(0, tg.t - now);
      if (tg.campaign && diff <= 0) { el.hidden = true; return; }
      if (lbl && lbl.textContent !== tg.text) lbl.textContent = tg.text;
      const h = Math.floor(diff / 36e5); diff -= h * 36e5;
      const m = Math.floor(diff / 6e4); diff -= m * 6e4;
      const s = Math.floor(diff / 1e3);
      H.textContent = pad(h); M.textContent = pad(m); S.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- cart drawer ---------- */
  const Cart = {
    get el() { return $('[data-cart-drawer]'); },
    open() {
      const el = this.el; if (!el) return false;
      el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('no-scroll');
      const x = $('.cdw__x', el); x && x.focus({ preventScroll: true });
      return true;
    },
    close() {
      const el = this.el; if (!el) return;
      el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('no-scroll');
    },
    async fetch() {
      const r = await fetch(SF.routes.cart + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      return r.json();
    },
    async refresh() { const c = await this.fetch(); this.render(c); return c; },
    async change(key, quantity) {
      const box = $('[data-cart-items]'); box && box.classList.add('is-busy');
      try {
        const r = await fetch(SF.routes.cartChange + '.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        this.render(await r.json());
      } finally { box && box.classList.remove('is-busy'); }
    },
    render(c) {
      $$('[data-cart-count]').forEach((n) => { n.textContent = c.item_count; n.hidden = c.item_count === 0; });
      const lbl = $('[data-cart-count-label]'); if (lbl) lbl.textContent = c.item_count ? `(${c.item_count})` : '';
      const items = $('[data-cart-items]'); const foot = $('[data-cart-foot]');
      if (!items) return;
      if (!c.item_count) {
        items.innerHTML = `<div class="cdw__empty">${icon('bag')}<p>Sepetin şimdilik boş.</p><a href="${esc(SF.routes.root)}#urun" class="btn btn--dark" data-cart-close>Filtreleri keşfet</a></div>`;
        foot && (foot.hidden = true);
      } else {
        items.innerHTML = c.items.map((it) => {
          const img = it.image ? `${it.image}${it.image.includes('?') ? '&' : '?'}width=180` : '';
          const props = Object.entries(it.properties || {}).filter(([k, v]) => v && k.charAt(0) !== '_')
            .map(([k, v]) => `<span class="citem__prop">${esc(k)}: ${esc(v)}</span>`).join('');
          const variant = it.variant_title && it.variant_title !== 'Default Title' ? `<span class="citem__var">${esc(it.variant_title)}</span>` : '';
          const strike = it.original_line_price > it.final_line_price ? `<s>${formatMoney(it.original_line_price)}</s>` : '';
          return `<div class="citem" data-key="${esc(it.key)}">
            <a href="${esc(it.url)}" class="citem__img">${img ? `<img src="${esc(img)}" alt="" loading="lazy" width="72" height="72">` : ''}</a>
            <div class="citem__info">
              <a href="${esc(it.url)}" class="citem__title">${esc(it.product_title)}</a>
              ${variant}${props}
              <div class="citem__row">
                <span class="qty">
                  <button type="button" data-qty="${it.quantity - 1}" aria-label="Azalt">${icon('minus')}</button>
                  <span>${it.quantity}</span>
                  <button type="button" data-qty="${it.quantity + 1}" aria-label="Artır">${icon('plus')}</button>
                </span>
                <button type="button" class="citem__rm" data-qty="0">Kaldır</button>
              </div>
            </div>
            <div class="citem__price">${formatMoney(it.final_line_price)}${strike}</div>
          </div>`;
        }).join('');
        foot && (foot.hidden = false);
      }
      const sub = $('[data-cart-subtotal]'); if (sub) sub.textContent = formatMoney(c.total_price);

      const ship = $('[data-cart-ship]');
      if (ship) {
        const goal = SF.freeShipping || 0;
        if (goal > 0 && c.item_count) {
          const left = goal - c.total_price;
          $('[data-cart-ship-text]', ship).textContent = left > 0 ? `Ücretsiz kargo için ${formatMoney(left)} kaldı` : 'Tebrikler, kargo ücretsiz! 🎉';
          $('[data-cart-ship-bar]', ship).style.width = Math.min(100, (c.total_price / goal) * 100) + '%';
          ship.hidden = false;
        } else ship.hidden = true;
      }
    }
  };
  SF.Cart = Cart;

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener && $('[data-cart-drawer]') && !document.body.classList.contains('template-cart')) {
      e.preventDefault(); Cart.refresh(); Cart.open(); return;
    }
    if (e.target.closest('[data-cart-close]')) { Cart.close(); return; }
    const q = e.target.closest('.cdw [data-qty]');
    if (q) { const row = q.closest('[data-key]'); Cart.change(row.dataset.key, Math.max(0, parseInt(q.dataset.qty, 10))); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { Cart.close(); closeMenu(); } });

  /* ---------- mobile menu ---------- */
  function closeMenu() { const m = $('[data-menu]'); if (m && !m.hidden) { m.hidden = true; document.documentElement.classList.remove('no-scroll'); } }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-menu-open]')) { const m = $('[data-menu]'); if (m) { m.hidden = false; document.documentElement.classList.add('no-scroll'); } }
    else if (e.target.closest('[data-menu-close]')) closeMenu();
  });

  /* ---------- gallery ---------- */
  function initGallery(root) {
    const track = $('[data-slides]', root);
    if (!track) return null;
    const slides = $$('.mp__slide', track);
    const thumbs = $$('.mp__thumb', root);
    const dots = $$('.mp__dots span', root);
    let index = 0;
    const setActive = (i) => {
      index = i;
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      const t = thumbs[i]; if (t && t.parentElement) {
        const p = t.parentElement;
        if (p.scrollWidth > p.clientWidth) p.scrollTo({ left: t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
      }
    };
    const go = (i, smooth = true) => {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      setActive(i);
    };
    thumbs.forEach((t, k) => t.addEventListener('click', () => go(k)));
    const prev = $('[data-prev]', root), next = $('[data-next]', root);
    prev && prev.addEventListener('click', () => go(index - 1));
    next && next.addEventListener('click', () => go(index + 1));
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== index) setActive(i);
      });
    }, { passive: true });
    return {
      go,
      goToMedia(id) { const k = slides.findIndex((s) => s.dataset.mediaId === String(id)); if (k > -1) go(k); },
      goToAlt(name) {
        if (!name) return false;
        const n = name.toLocaleLowerCase('tr');
        const k = slides.findIndex((s) => (s.dataset.alt || '').toLocaleLowerCase('tr').includes(n));
        if (k > -1) { go(k); return true; }
        return false;
      }
    };
  }

  /* ---------- product section ---------- */
  function initProduct(section) {
    if (section.dataset.ready) return;
    section.dataset.ready = '1';
    const gallery = initGallery($('[data-gallery]', section) || section);
    const offers = $$('[data-offer]', section);
    const form = $('form[action*="/cart/add"]', section);
    const idInput = form ? ($('[data-variant-input]', form) || $('input[name="id"]', form)) : null;
    const propsBox = form ? $('[data-props]', form) : null;
    const atc = form ? $('[data-atc]', form) : null;
    const atcText = $('[data-atc-text]', section);
    const atcBase = atcText ? (atcText.dataset.base || 'Sepete Ekle') : 'Sepete Ekle';
    const errorEl = $('[data-atc-error]', section);
    const satc = $('[data-satc]', section);
    const satcPrice = satc ? $('[data-satc-price]', satc) : null;
    const colors = SF.colors || [];
    let current = offers.find((o) => o.classList.contains('is-selected')) || offers[0] || null;
    let picks = [0];

    const countOf = (o) => Math.max(1, parseInt((o && o.dataset.count) || '1', 10));
    const isAll = (o) => colors.length > 0 && countOf(o) >= colors.length;

    function writeProps() {
      if (!propsBox || !current || !colors.length) return;
      const n = countOf(current);
      if (isAll(current)) {
        propsBox.innerHTML = `<input type="hidden" name="properties[Renkler]" value="${esc(colors.map((c) => c.name).join(', '))}">`;
      } else {
        propsBox.innerHTML = picks.slice(0, n).map((v, i) =>
          `<input type="hidden" name="properties[${n > 1 ? `${i + 1}. Filtre` : 'Renk'}]" value="${esc(colors[v] ? colors[v].name : '')}">`).join('');
      }
    }

    function renderPickers() {
      offers.forEach((o) => { const b = $('[data-colors]', o); if (b && o !== current) b.innerHTML = ''; });
      if (!current || !colors.length) return;
      const box = $('[data-colors]', current);
      if (!box) return;
      const n = countOf(current);
      if (isAll(current)) {
        box.innerHTML = `<div class="pick pick--all"><span class="pick__label"><b>${colors.length} rengin tamamı</b> pakette</span><span class="pick__dots">${colors.map((c) => `<i style="--c:${esc(c.hex)}" title="${esc(c.name)}"></i>`).join('')}</span></div>`;
      } else {
        const next = [];
        for (let i = 0; i < n; i++) {
          let v = picks[i];
          if (v == null || v >= colors.length) {
            v = colors.findIndex((_, k) => !next.includes(k));
            if (v < 0) v = 0;
          }
          next.push(v);
        }
        picks = next;
        box.innerHTML = picks.map((v, row) => `
          <div class="pick" data-row="${row}">
            <span class="pick__label">${n > 1 ? `${row + 1}. filtre` : 'Renk'}: <b data-pick-name>${esc(colors[v].name)}</b></span>
            <span class="pick__sw">${colors.map((c, k) => `<button type="button" class="sw-dot${k === v ? ' is-active' : ''}" style="--c:${esc(c.hex)}" data-k="${k}" aria-label="${esc(c.name)}" aria-pressed="${k === v}" title="${esc(c.name)}"></button>`).join('')}</span>
          </div>`).join('');
      }
      writeProps();
    }

    function updatePrice() {
      if (!current) return;
      const price = parseInt(current.dataset.price, 10);
      const soldout = current.classList.contains('is-soldout');
      if (atcText) atcText.textContent = soldout ? 'Tükendi' : `${atcBase} — ${formatMoney(price)}`;
      if (atc) atc.disabled = soldout;
      if (satcPrice) satcPrice.textContent = formatMoney(price);
    }

    let productJson = null;
    try { productJson = JSON.parse(($('[data-product-json]', section) || {}).textContent || 'null'); } catch (e) { productJson = null; }

    function select(o, opts = {}) {
      if (!o || o.classList.contains('is-soldout')) return;
      current = o;
      offers.forEach((x) => { const on = x === o; x.classList.toggle('is-selected', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
      if (idInput) idInput.value = o.dataset.variantId;
      renderPickers();
      updatePrice();
      if (!opts.silent && document.body.classList.contains('template-product')) {
        const url = new URL(location.href); url.searchParams.set('variant', o.dataset.variantId);
        history.replaceState(history.state, '', url.toString());
      }
      if (productJson && gallery) {
        const v = (productJson.variants || []).find((x) => String(x.id) === o.dataset.variantId);
        if (v && v.featured_media) gallery.goToMedia(v.featured_media.id);
      }
    }

    function showColor(k) { if (gallery && colors[k]) gallery.goToAlt(colors[k].name); }

    offers.forEach((o) => {
      o.addEventListener('click', (e) => {
        const dot = e.target.closest('.sw-dot');
        if (dot && o === current) {
          const rowEl = dot.closest('.pick');
          const row = parseInt(rowEl.dataset.row, 10);
          const k = parseInt(dot.dataset.k, 10);
          picks[row] = k;
          $$('.sw-dot', rowEl).forEach((d) => { const on = d === dot; d.classList.toggle('is-active', on); d.setAttribute('aria-pressed', on); });
          const nm = $('[data-pick-name]', rowEl); if (nm) nm.textContent = colors[k].name;
          writeProps();
          showColor(k);
          return;
        }
        if (o !== current) select(o);
      });
      o.addEventListener('keydown', (e) => {
        if ((e.key === 'Enter' || e.key === ' ') && e.target === o) { e.preventDefault(); select(o); }
      });
    });

    // pick from color cards elsewhere on the page
    document.addEventListener('sf:pick', (e) => {
      const k = e.detail;
      if (!current) return;
      if (isAll(current)) { const single = offers.find((o) => countOf(o) === 1 && !o.classList.contains('is-soldout')); if (single) select(single, { silent: true }); }
      picks[0] = k;
      renderPickers();
      showColor(k);
      const target = $('[data-offers]', section) || section;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    // add to cart
    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        writeProps();
        if (errorEl) errorEl.hidden = true;
        atc && atc.classList.add('is-loading');
        try {
          const r = await fetch(SF.routes.cartAdd + '.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form)
          });
          const data = await r.json();
          if (!r.ok || data.status) throw new Error(data.description || data.message || 'Ürün sepete eklenemedi.');
          await Cart.refresh();
          if (!Cart.open()) location.href = SF.routes.cart;
        } catch (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        } finally {
          atc && atc.classList.remove('is-loading');
        }
      });
    }

    // sticky bar
    if (satc && atc && 'IntersectionObserver' in window) {
      const satcBtn = $('[data-satc-btn]', satc);
      satcBtn && satcBtn.addEventListener('click', () => {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(atc); else atc.click();
      });
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        satc.classList.toggle('is-visible', show);
        satc.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(atc);
    }

    renderPickers();
    updatePrice();
  }

  /* ---------- filter preview ---------- */
  function initPreview(fp) {
    if (fp.dataset.ready) return;
    fp.dataset.ready = '1';
    const frame = $('[data-fp-frame]', fp);
    const range = $('[data-fp-range]', fp);
    const name = $('[data-fp-name]', fp);
    const sws = $$('[data-fp-sw]', fp);
    const setPos = (v) => frame.style.setProperty('--pos', v + '%');
    range && range.addEventListener('input', () => setPos(range.value));
    sws.forEach((b) => b.addEventListener('click', () => {
      fp.style.setProperty('--tint', b.dataset.color);
      if (name) name.textContent = b.dataset.name;
      sws.forEach((x) => { const on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on); });
    }));
    // a gentle hint animation the first time the preview is seen
    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const io = new IntersectionObserver(([e]) => {
        if (!e.isIntersecting) return;
        io.disconnect();
        const start = performance.now();
        const step = (t) => {
          const p = Math.min(1, (t - start) / 1600);
          const v = 50 + Math.sin(p * Math.PI * 2) * 22 * (1 - p);
          setPos(v.toFixed(1)); if (range) range.value = v;
          if (p < 1) requestAnimationFrame(step); else { setPos(50); if (range) range.value = 50; }
        };
        requestAnimationFrame(step);
      }, { threshold: 0.5 });
      io.observe(frame);
    }
  }

  /* ---------- color grid -> product ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-pick]');
    if (!b) return;
    const k = parseInt(b.dataset.pick, 10);
    if ($('[data-product-section]')) document.dispatchEvent(new CustomEvent('sf:pick', { detail: k }));
    else location.href = SF.routes.root + '#urun';
  });

  /* ---------- social proof slider ---------- */
  function initSlider(wrap) {
    const row = $('[data-sp-row]', wrap); if (!row || wrap.dataset.ready) return;
    wrap.dataset.ready = '1';
    const by = () => row.clientWidth * 0.8;
    const p = $('[data-sp-prev]', wrap), n = $('[data-sp-next]', wrap);
    p && p.addEventListener('click', () => row.scrollBy({ left: -by(), behavior: 'smooth' }));
    n && n.addEventListener('click', () => row.scrollBy({ left: by(), behavior: 'smooth' }));
  }

  function init(root = document) {
    $$('[data-countdown]', root).forEach(initCountdown);
    $$('[data-product-section]', root).forEach(initProduct);
    $$('[data-fp]', root).forEach(initPreview);
    $$('.sp__wrap', root).forEach(initSlider);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
